'use client'

import { reloadPage } from '@marketplace-web/shared/browser-util'
import { declineCancellationAgreement } from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { ResponseCode } from '@marketplace-web/core-api/api-client-util'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

type Props = ConversationActionProps

const CancellationDecline = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  async function declineAgreement() {
    if (!transactionId) return

    const response = await declineCancellationAgreement(transactionId)

    if (response.code === ResponseCode.Ok) reloadPage()
  }

  if (!transactionId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={declineAgreement}
    />
  )
}

export default CancellationDecline
